var _jsxFileName = "/builds/zillow/hackweek/military-rent-affordability-calculator/src/components/MilitaryRentAffordabilityCalculator/mrac-bah-statement/index.jsx",
    _this = this;

import React from 'react';
import { Paragraph } from '@zillow/constellation';
import PropTypes from 'prop-types';

var MilitaryBahStatement = function MilitaryBahStatement(_ref) {
  var militaryPaygrade = _ref.militaryPaygrade,
      zipCode = _ref.zipCode,
      dependants = _ref.dependants,
      monthlyBah = _ref.monthlyBah,
      location = _ref.location,
      locationCode = _ref.locationCode;

  var buildUnfulfilledParamsStatement = function buildUnfulfilledParamsStatement() {
    var missingValues = [];

    if (militaryPaygrade == null) {
      missingValues.push('Paygrade');
    }

    if (zipCode == null) {
      missingValues.push('Zip Code');
    }

    if (dependants == null) {
      missingValues.push('Dependants');
    }

    var missingValuesStatement = null;

    if (missingValues.length > 0) {
      missingValuesStatement = missingValues.join(missingValues.length > 2 ? ', ' : ' and ');
    } else {
      return null;
    }

    var lastCommaIndex = missingValuesStatement.lastIndexOf(', ');

    if (lastCommaIndex > 0) {
      missingValuesStatement = missingValuesStatement.substring(0, lastCommaIndex + 1) + " and" + missingValuesStatement.substring(lastCommaIndex + 1);
    }

    return missingValuesStatement;
  };

  var unfulfilledParamsStatement = buildUnfulfilledParamsStatement();

  if (unfulfilledParamsStatement != null) {
    return /*#__PURE__*/React.createElement(Paragraph, {
      marginY: "md",
      __self: _this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 47,
        columnNumber: 13
      }
    }, "Please enter your ", /*#__PURE__*/React.createElement("strong", {
      __self: _this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 48,
        columnNumber: 35
      }
    }, unfulfilledParamsStatement), " to find your Basic Allowance for Housing");
  }

  if (monthlyBah != null) {
    return /*#__PURE__*/React.createElement(Paragraph, {
      marginY: "md",
      __self: _this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 55,
        columnNumber: 13
      }
    }, "Your monthly Basic Allowance for Housing in area", ' ', /*#__PURE__*/React.createElement("strong", {
      __self: _this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 57,
        columnNumber: 17
      }
    }, location, " (", locationCode, ")"), ' ', "is", ' ', /*#__PURE__*/React.createElement("strong", {
      __self: _this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 61,
        columnNumber: 17
      }
    }, monthlyBah.toLocaleString('en-US', {
      style: 'currency',
      currency: 'USD'
    }), "/mo"));
  }

  return /*#__PURE__*/React.createElement(Paragraph, {
    marginY: "md",
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 68,
      columnNumber: 9
    }
  }, "Unable to determine your monthly Basic Allowance for Housing.");
};

MilitaryBahStatement.propTypes = process.env.NODE_ENV !== "production" ? {
  militaryPaygrade: PropTypes.string.isRequired,
  zipCode: PropTypes.number.isRequired,
  dependants: PropTypes.bool.isRequired,
  monthlyBah: PropTypes.number.isRequired,
  location: PropTypes.string.isRequired,
  locationCode: PropTypes.string.isRequired
} : {};
export default MilitaryBahStatement;